<template>
  <h1 class="section-header">
    <div class="row full-width">
      <button v-if="back" style='margin-right: 10px' @click="$router.push(back)">
        <h-icon >
          arrow_back
        </h-icon> 
      </button>
      <slot></slot>
    </div>
  </h1>
</template>

<script>
export default {
  props: ["back"],
}
</script>

<style>

</style>
